import React from 'react';
import styled from 'styled-components';

const StyledCenter = styled.div`
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const BrokenPage = () => (
  <StyledCenter>
    <h1>404 Not Found!</h1>
    <p>
      The page you are looking for doesn't exist or is coming soon!. Sorry for
      inconvenience
    </p>
  </StyledCenter>
);

export default BrokenPage;
